import { LatLngBounds } from 'leaflet';
import { useTranslation } from 'react-i18next';
import { LayersControl, Rectangle } from 'react-leaflet';

const pathOptions = {
  color: '#007DBA',
  fillColor: 'transparent',
  dashArray: '10, 10',
};

interface SearchBoundsLayerProps {
  bounds: LatLngBounds;
}

export const SearchBoundsLayer = ({ bounds }: SearchBoundsLayerProps) => {
  const { t } = useTranslation();

  return (
    <LayersControl.Overlay name={t('SearchArea')} checked={true}>
      <Rectangle bounds={bounds} pathOptions={pathOptions} interactive={false} />
    </LayersControl.Overlay>
  );
};

export default SearchBoundsLayer;
